import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { Link } from 'react-router-dom';
import {
  FencingSwordsIcon,
  VideoIcon,
  EditIcon,
  TimerIcon
} from '../components/FencingIcons';

const ToolCard = ({ to, icon: Icon, title, description, ariaLabel }) => (
  <Link
    to={to}
    component={TouchableOpacity}
    style={styles.card}
    activeOpacity={0.9}
    accessibilityRole="button"
    aria-label={ariaLabel}
  >
    <Icon style={styles.icon} />
    <View style={styles.textContainer}>
      <Text style={styles.cardTitle}>{title}</Text>
      <Text style={styles.cardDesc}>{description}</Text>
    </View>
  </Link>
);

const ToolPage = () => {
  const tools = [
    {
      id: 'score',
      to: '/tools/segnapunti',
      icon: FencingSwordsIcon,
      title: 'Segnapunti',
      description: 'Punteggio rapido',
      ariaLabel: 'Segnapunti'
    },
    {
      id: 'video-arbitraggio',
      to: '/tools/video-arbitraggio',
      icon: VideoIcon,
      title: 'Video Arbitraggio',
      description: 'Replay ultimi 5s',
      ariaLabel: 'Video Arbitraggio'
    },
    {
      id: 'logger',
      to: '/tools/logger',
      icon: EditIcon,
      title: 'Logger',
      description: 'Conta eventi',
      ariaLabel: 'Logger eventi'
    },
    {
      id: 'interval',
      to: '/tools/interval-timer',
      icon: TimerIcon,
      title: 'Interval Timer',
      description: 'Timer intervalli',
      ariaLabel: 'Interval Timer'
    }
  ];

  return (
    <View style={styles.container} accessibilityRole="main">
      <Text style={styles.title}>Strumenti Utili</Text>
      <View style={styles.grid}>
        {tools.map(tool => (
          <ToolCard key={tool.id} {...tool} />
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 24,
    backgroundColor: '#f7fafd',
  },
  title: {
    fontSize: 26,
    fontFamily: 'System',
    fontWeight: '700',
    color: '#1a365d',
    marginBottom: 28,
    textAlign: 'center',
    letterSpacing: 0.3,
    lineHeight: 32,
  },
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: 20,
    paddingHorizontal: 16,
  },
  card: {
    width: 164,
    height: 164,
    backgroundColor: '#ffffff',
    borderRadius: 18,
    padding: 20,
    alignItems: 'center',
    justifyContent: 'space-between',
    boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.08)',
    textDecorationLine: 'none',
  },
  textContainer: {
    alignItems: 'center',
    width: '100%',
  },
  icon: {
    fontSize: 48,
    color: '#1976d2',
    marginBottom: 12,
  },
  cardTitle: {
    fontSize: 17,
    fontFamily: 'System',
    fontWeight: '600',
    color: '#2c5282',
    marginBottom: 8,
    textAlign: 'center',
    letterSpacing: 0.2,
    lineHeight: 22,
    textDecorationLine: 'none',
  },
  cardDesc: {
    fontSize: 14,
    fontFamily: 'System',
    fontWeight: '400',
    color: '#4a5568',
    textAlign: 'center',
    lineHeight: 20,
    opacity: 0.95,
    textDecorationLine: 'none',
  },
});

export default ToolPage;
